module.exports = __webpack_public_path__ + "images/VerticalDots.abf07f28850b09d9b2c67faba3e6cb92.svg";